export default __webpack_public_path__ + "img/e5b185900490c4ca2a0d96df6e93f770.svg";